<template>
  <div class="relative flex w-full">
    <button
      @click="open = !open"
      type="button"
      class="relative flex-grow w-auto py-2 pl-3 pr-10 text-left border-0 border-gray-300 shadow-none cursor-pointer bg-kas-500 focus:ring-2 focus:ring-offset-2 focus:ring-offset-kas-500 focus:ring-white sm:text-sm"
    >
      <span class="block text-lg font-medium truncate text-kas-100">
        {{ selected ?? placeholder }}
      </span>
      <span
        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
      >
        <svg
          class="w-5 h-5 text-kas-100"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <!--
      Select popover, show/hide based on select state.

      Entering: ""
        From: ""
        To: ""
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="absolute z-50 w-full bg-white shadow-lg" v-if="open">
      <ul
        role="listbox"
        class="py-1 overflow-auto text-base max-h-60 ring-0 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      >
        <UseFocusTrap v-if="open" :options="{ immediate: true }">
          <li
            tabindex="1"
            v-for="value in values"
            @click="
              $emit('selected', value);
              open = false;
            "
            @keydown.enter="
              $emit('selected', value);
              open = false;
            "
            @keydown.space="
              $emit('selected', value);
              open = false;
            "
            :key="value"
            class="relative py-2 pl-3 text-gray-900 border-t border-b border-transparent cursor-pointer select-none focus:bg-gray-100 focus:outline-none focus:border-kas-500 focus:text-gray-900 pr-9 hover:text-white hover:bg-kas-500"
          >
            <span
              class="block truncate"
              :class="{
                'font-semibold': value === selected,
                'font-normal': value !== selected,
              }"
              >{{ value }}</span
            >
            <span
              v-if="value === selected"
              class="absolute inset-y-0 right-0 flex items-center pr-4 text-kas-500 hover:text-white"
            >
              <svg
                class="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </li>
        </UseFocusTrap>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { UseFocusTrap } from "@vueuse/integrations/useFocusTrap/component";
import { emulateTab } from 'emulate-tab';

export default {
  name: "Selecter",
  components: { UseFocusTrap },
  props: {
    placeholder: {
      required: false,
      type: String,
      default: () => "Valitse",
    },
    selected: {
      required: false,
      default: () => null,
      type: String,
    },
    values: {
      required: true,
      type: Array,
    },
  },
  setup() {
    const open = ref(false);
    const closeSelector = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        open.value = false;
      }
    };
    const selectWithArrows = (event) => {
      if (open.value && event.key === "ArrowDown") {
        event.preventDefault();
        emulateTab();
      }
      if (open.value && event.key === "ArrowUp") {
        event.preventDefault();
        emulateTab.backwards();
      }
    };
    return {
      open,
      closeSelector,
      selectWithArrows
    };
  },
  mounted() {
    window.addEventListener("keydown", this.closeSelector);
    window.addEventListener("keydown", this.selectWithArrows);
  },
  unmounted() {
    window.removeEventListener("keydown", this.closeSelector);
    window.removeEventListener("keydown", this.selectWithArrows);
  },
};
</script>
